export default {
  init() {
    if (typeof servicesData !== 'undefined') {

      const serviceModal = document.querySelector('.main-service-item');

      const handleClick = button => {
        const selectedService = servicesData.find(
          service => service.id == button.dataset.id
        );

        const serviceIcon = document.querySelector(
          '.service-modal .service-icon'
        );
        const serviceTitle = document.querySelector(
          '.service-modal .service-title'
        );
        const serviceDescription = document.querySelector(
          '.service-modal .service-description'
        );
        const serviceBackground = document.querySelector('.service-modal .service-image');

        serviceIcon.src = `/wp-content/themes/bestdrive/src/assets/icons/${selectedService.icon}.svg`;
        serviceTitle.innerHTML = selectedService.name;
        serviceDescription.innerHTML = selectedService.desc;

        if (selectedService.cover) {
          serviceBackground.style.backgroundImage = `url('${selectedService.cover.variants[0].url}')`;
        }

        document.querySelector('body').classList.add('noscroll');
        serviceModal.classList.add('-show');
      };

      const serviceEl = document.querySelectorAll('.main-services-list-item');
      [...serviceEl].forEach(button => {
        button.addEventListener('click', () => {
          handleClick(button);
        });
      });

      const modalCloseButton = document.querySelector(
        '.main-service-item .close-icon'
      );
      modalCloseButton.addEventListener('click', function() {
        this.closest('.main-service-item').classList.remove('-show');
        document.querySelector('body').classList.remove('noscroll');
      });

      document.addEventListener('click', function(event) {
        if (
          event.target.closest('.service-modal') ||
          event.target.closest('.main-services-list-item') ||
          event.target.closest('#leadModal')
        )
          return;

        serviceModal.classList.remove('-show');
        document.querySelector('body').classList.remove('noscroll');
      });
    }
  }
};
